// Ülke yerel saatine göre planlama: numaranın ülke kodundan saat dilimi, dilimdeki duvar saatinden UTC anı.
// Ülke tablosu ve hesaplar "WhatsApp Toplu Mesaj Gönderme" referans projesinden (src/phone.js, src/schedule.js).
import _ from 'lodash';

export const DEFAULT_TZ = 'Europe/Istanbul';
export const UNKNOWN_CODE = '__unknown';

// code: uluslararası kod, name: Türkçe ad, tz: ana saat dilimi
export const COUNTRIES = [
	{ code: '90', iso: 'TR', name: 'Türkiye', tz: 'Europe/Istanbul' },
	{ code: '49', iso: 'DE', name: 'Almanya', tz: 'Europe/Berlin' },
	{ code: '971', iso: 'AE', name: 'BAE', tz: 'Asia/Dubai' },
	{ code: '44', iso: 'GB', name: 'Birleşik Krallık', tz: 'Europe/London' },
	{ code: '1', iso: 'US', name: 'ABD / Kanada', tz: 'America/New_York' },
	{ code: '31', iso: 'NL', name: 'Hollanda', tz: 'Europe/Amsterdam' },
	{ code: '32', iso: 'BE', name: 'Belçika', tz: 'Europe/Brussels' },
	{ code: '33', iso: 'FR', name: 'Fransa', tz: 'Europe/Paris' },
	{ code: '34', iso: 'ES', name: 'İspanya', tz: 'Europe/Madrid' },
	{ code: '39', iso: 'IT', name: 'İtalya', tz: 'Europe/Rome' },
	{ code: '41', iso: 'CH', name: 'İsviçre', tz: 'Europe/Zurich' },
	{ code: '43', iso: 'AT', name: 'Avusturya', tz: 'Europe/Vienna' },
	{ code: '45', iso: 'DK', name: 'Danimarka', tz: 'Europe/Copenhagen' },
	{ code: '46', iso: 'SE', name: 'İsveç', tz: 'Europe/Stockholm' },
	{ code: '47', iso: 'NO', name: 'Norveç', tz: 'Europe/Oslo' },
	{ code: '48', iso: 'PL', name: 'Polonya', tz: 'Europe/Warsaw' },
	{ code: '30', iso: 'GR', name: 'Yunanistan', tz: 'Europe/Athens' },
	{ code: '36', iso: 'HU', name: 'Macaristan', tz: 'Europe/Budapest' },
	{ code: '40', iso: 'RO', name: 'Romanya', tz: 'Europe/Bucharest' },
	{ code: '351', iso: 'PT', name: 'Portekiz', tz: 'Europe/Lisbon' },
	{ code: '353', iso: 'IE', name: 'İrlanda', tz: 'Europe/Dublin' },
	{ code: '358', iso: 'FI', name: 'Finlandiya', tz: 'Europe/Helsinki' },
	{ code: '359', iso: 'BG', name: 'Bulgaristan', tz: 'Europe/Sofia' },
	{ code: '380', iso: 'UA', name: 'Ukrayna', tz: 'Europe/Kyiv' },
	{ code: '381', iso: 'RS', name: 'Sırbistan', tz: 'Europe/Belgrade' },
	{ code: '385', iso: 'HR', name: 'Hırvatistan', tz: 'Europe/Zagreb' },
	{ code: '386', iso: 'SI', name: 'Slovenya', tz: 'Europe/Ljubljana' },
	{ code: '387', iso: 'BA', name: 'Bosna-Hersek', tz: 'Europe/Sarajevo' },
	{ code: '389', iso: 'MK', name: 'Kuzey Makedonya', tz: 'Europe/Skopje' },
	{ code: '355', iso: 'AL', name: 'Arnavutluk', tz: 'Europe/Tirane' },
	{ code: '383', iso: 'XK', name: 'Kosova', tz: 'Europe/Belgrade' },
	{ code: '420', iso: 'CZ', name: 'Çekya', tz: 'Europe/Prague' },
	{ code: '421', iso: 'SK', name: 'Slovakya', tz: 'Europe/Bratislava' },
	{ code: '7', iso: 'RU', name: 'Rusya / Kazakistan', tz: 'Europe/Moscow' },
	{ code: '994', iso: 'AZ', name: 'Azerbaycan', tz: 'Asia/Baku' },
	{ code: '995', iso: 'GE', name: 'Gürcistan', tz: 'Asia/Tbilisi' },
	{ code: '998', iso: 'UZ', name: 'Özbekistan', tz: 'Asia/Tashkent' },
	{ code: '993', iso: 'TM', name: 'Türkmenistan', tz: 'Asia/Ashgabat' },
	{ code: '996', iso: 'KG', name: 'Kırgızistan', tz: 'Asia/Bishkek' },
	{ code: '992', iso: 'TJ', name: 'Tacikistan', tz: 'Asia/Dushanbe' },
	{ code: '98', iso: 'IR', name: 'İran', tz: 'Asia/Tehran' },
	{ code: '964', iso: 'IQ', name: 'Irak', tz: 'Asia/Baghdad' },
	{ code: '966', iso: 'SA', name: 'Suudi Arabistan', tz: 'Asia/Riyadh' },
	{ code: '974', iso: 'QA', name: 'Katar', tz: 'Asia/Qatar' },
	{ code: '965', iso: 'KW', name: 'Kuveyt', tz: 'Asia/Kuwait' },
	{ code: '973', iso: 'BH', name: 'Bahreyn', tz: 'Asia/Bahrain' },
	{ code: '968', iso: 'OM', name: 'Umman', tz: 'Asia/Muscat' },
	{ code: '962', iso: 'JO', name: 'Ürdün', tz: 'Asia/Amman' },
	{ code: '961', iso: 'LB', name: 'Lübnan', tz: 'Asia/Beirut' },
	{ code: '963', iso: 'SY', name: 'Suriye', tz: 'Asia/Damascus' },
	{ code: '972', iso: 'IL', name: 'İsrail', tz: 'Asia/Jerusalem' },
	{ code: '970', iso: 'PS', name: 'Filistin', tz: 'Asia/Gaza' },
	{ code: '20', iso: 'EG', name: 'Mısır', tz: 'Africa/Cairo' },
	{ code: '212', iso: 'MA', name: 'Fas', tz: 'Africa/Casablanca' },
	{ code: '213', iso: 'DZ', name: 'Cezayir', tz: 'Africa/Algiers' },
	{ code: '216', iso: 'TN', name: 'Tunus', tz: 'Africa/Tunis' },
	{ code: '218', iso: 'LY', name: 'Libya', tz: 'Africa/Tripoli' },
	{ code: '234', iso: 'NG', name: 'Nijerya', tz: 'Africa/Lagos' },
	{ code: '254', iso: 'KE', name: 'Kenya', tz: 'Africa/Nairobi' },
	{ code: '27', iso: 'ZA', name: 'Güney Afrika', tz: 'Africa/Johannesburg' },
	{ code: '91', iso: 'IN', name: 'Hindistan', tz: 'Asia/Kolkata' },
	{ code: '92', iso: 'PK', name: 'Pakistan', tz: 'Asia/Karachi' },
	{ code: '880', iso: 'BD', name: 'Bangladeş', tz: 'Asia/Dhaka' },
	{ code: '86', iso: 'CN', name: 'Çin', tz: 'Asia/Shanghai' },
	{ code: '81', iso: 'JP', name: 'Japonya', tz: 'Asia/Tokyo' },
	{ code: '82', iso: 'KR', name: 'Güney Kore', tz: 'Asia/Seoul' },
	{ code: '60', iso: 'MY', name: 'Malezya', tz: 'Asia/Kuala_Lumpur' },
	{ code: '62', iso: 'ID', name: 'Endonezya', tz: 'Asia/Jakarta' },
	{ code: '65', iso: 'SG', name: 'Singapur', tz: 'Asia/Singapore' },
	{ code: '66', iso: 'TH', name: 'Tayland', tz: 'Asia/Bangkok' },
	{ code: '84', iso: 'VN', name: 'Vietnam', tz: 'Asia/Ho_Chi_Minh' },
	{ code: '63', iso: 'PH', name: 'Filipinler', tz: 'Asia/Manila' },
	{ code: '61', iso: 'AU', name: 'Avustralya', tz: 'Australia/Sydney' },
	{ code: '64', iso: 'NZ', name: 'Yeni Zelanda', tz: 'Pacific/Auckland' },
	{ code: '52', iso: 'MX', name: 'Meksika', tz: 'America/Mexico_City' },
	{ code: '55', iso: 'BR', name: 'Brezilya', tz: 'America/Sao_Paulo' },
	{ code: '54', iso: 'AR', name: 'Arjantin', tz: 'America/Argentina/Buenos_Aires' },
	{ code: '56', iso: 'CL', name: 'Şili', tz: 'America/Santiago' },
	{ code: '57', iso: 'CO', name: 'Kolombiya', tz: 'America/Bogota' },
	{ code: '51', iso: 'PE', name: 'Peru', tz: 'America/Lima' },
];

const BY_CODE = _.keyBy(COUNTRIES, 'code');

export const TIMEZONES = _.uniq(
	_.map(COUNTRIES, 'tz').concat(['Europe/Istanbul', 'UTC', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/Toronto', 'Asia/Almaty', 'Australia/Perth'])
).sort();

// Tarayıcının saat dilimi (referans saat olarak gösterilir)
export function browserTz() {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TZ;
	} catch (e) {
		return DEFAULT_TZ;
	}
}

// "0555…" / "+90 555…" / "90555…@c.us" -> uluslararası kodlu rakamlar
export function normalizePhone(v) {
	let d = String(v || '')
		.replace(/@.*/, '')
		.replace(/\D/g, '');
	if (d.slice(0, 2) === '00') d = d.slice(2);
	if (d.length === 10 && d[0] === '5') d = '90' + d;
	else if (d.length === 11 && d[0] === '0') d = '90' + d.slice(1);
	return d;
}
// En uzun eşleşen önek; grup (@g.us) ya da tanınmayan numara için null
export function countryOf(id) {
	if (/@g\.us$/.test(String(id || ''))) return null;
	const d = normalizePhone(id);
	if (d.length < 8) return null;
	for (let len = 3; len >= 1; len--) if (BY_CODE[d.slice(0, len)]) return BY_CODE[d.slice(0, len)];
	return null;
}

const pad2 = (n) => String(n).padStart(2, '0');
export function partsInTz(date, tz) {
	const d = date instanceof Date ? date : new Date(date);
	try {
		const f = new Intl.DateTimeFormat('en-US', {
			timeZone: tz || DEFAULT_TZ,
			hour12: false,
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
			weekday: 'short',
		});
		const o = {};
		f.formatToParts(d).forEach((p) => {
			if (p.type !== 'literal') o[p.type] = p.value;
		});
		return { year: +o.year, month: +o.month, day: +o.day, hour: +o.hour % 24, minute: +o.minute, second: +o.second, weekday: o.weekday };
	} catch (e) {
		return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate(), hour: d.getUTCHours(), minute: d.getUTCMinutes(), second: d.getUTCSeconds(), weekday: '' };
	}
}
// Dilimin UTC'ye göre kayması (dk), verilen anda (yaz saati dâhil)
export function tzOffsetMinutes(tz, at) {
	const d = at ? new Date(at) : new Date();
	const p = partsInTz(d, tz);
	return Math.round((Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - d.getTime()) / 60000);
}
export function tzOffsetLabel(tz, at) {
	const m = tzOffsetMinutes(tz, at);
	const a = Math.abs(m);
	return 'UTC' + (m < 0 ? '−' : '+') + Math.floor(a / 60) + (a % 60 ? ':' + pad2(a % 60) : '');
}
// Dilimdeki duvar saati ("2026-10-23", "10:00") -> UTC anı
export function zonedToUtc(dateStr, timeStr, tz) {
	const [y, mo, d] = String(dateStr || '').split('-').map(Number);
	const [h, mi] = String(timeStr || '00:00').split(':').map(Number);
	if (!y || !mo || !d) return null;
	let guess = Date.UTC(y, mo - 1, d, h || 0, mi || 0, 0);
	for (let i = 0; i < 2; i++) guess = Date.UTC(y, mo - 1, d, h || 0, mi || 0, 0) - tzOffsetMinutes(tz, guess) * 60000;
	return new Date(guess);
}
export const timeInTz = (date, tz) => {
	const p = partsInTz(date, tz);
	return pad2(p.hour) + ':' + pad2(p.minute);
};
export const dateInTz = (date, tz) => {
	const p = partsInTz(date, tz);
	return pad2(p.day) + '.' + pad2(p.month) + '.' + p.year;
};
const isWeekendInTz = (date, tz) => {
	const w = partsInTz(date, tz).weekday;
	return w === 'Sat' || w === 'Sun';
};
// "2026-10-24" + n gün (duvar saati korunur; +86400000 yaz saatinde kayar)
function addDays(dateStr, n) {
	const [y, m, d] = String(dateStr).split('-').map(Number);
	const t = new Date(Date.UTC(y, m - 1, d + n));
	return t.getUTCFullYear() + '-' + pad2(t.getUTCMonth() + 1) + '-' + pad2(t.getUTCDate());
}

// Alıcıları ülke koduna göre dalgalara ayır. tzOverrides: { code: tz }
export function groupByCountry(targets, refTz, tzOverrides) {
	const map = {};
	_.each(targets, (it) => {
		const c = countryOf(it.id);
		const code = c ? c.code : UNKNOWN_CODE;
		if (!map[code])
			map[code] = {
				code,
				label: c ? c.name + ' (+' + c.code + ')' : 'Belirlenemeyen',
				tz: (tzOverrides && tzOverrides[code]) || (c ? c.tz : refTz || DEFAULT_TZ),
				unknown: !c,
				targets: [],
			};
		map[code].targets.push(it);
	});
	return _.sortBy(_.values(map), [(g) => (g.unknown ? 1 : 0), (g) => -g.targets.length]);
}

// Her dalganın gönderim anı. weekendRule 'next_business': hafta sonu ise sonraki iş gününe (yerel saat korunur)
export function computeWaves(groups, { dateStr, timeStr, weekendRule, refTz }) {
	return _.map(groups, (g) => {
		let at = zonedToUtc(dateStr, timeStr, g.tz);
		let shifted = false;
		if (at && weekendRule === 'next_business') {
			let ds = dateStr;
			for (let i = 0; i < 3 && isWeekendInTz(at, g.tz); i++) {
				ds = addDays(ds, 1);
				at = zonedToUtc(ds, timeStr, g.tz);
				shifted = true;
			}
		}
		return { ...g, send_at: at, shifted, local: at ? dateInTz(at, g.tz) + ' ' + timeInTz(at, g.tz) : '', ref: at ? dateInTz(at, refTz) + ' ' + timeInTz(at, refTz) : '' };
	});
}
